import React from 'react';

const funcDefault = () => {
  // This is intentional
};

export const GroupAccordionContext = React.createContext({
  data: [],
  selectedItems: {},
  disableSelection: false,
  disableDragAndDrop: false,
  showHorizontalDragHandleContainer: false,
  onSelectItem: funcDefault,
  onSelectGroup: funcDefault,
  onSelectAll: funcDefault,
  onUnselectItem: funcDefault,
  unSelectAll: funcDefault,
  onUnselectGroup: funcDefault,
});
